import React from "react";
import { WcStack, Box, WcPaper } from "@bpipartners/webui";
import { ForgotPasswordFormState } from "../../forms/login";
import axios from "axios";
import ForgotPasswordFormComposite from "./ForgotPasswordFormComposite";
import PasswordSentComposite from "./PasswordSentComposite";
import { AppContext } from "@guberno/utils/context";

export const ForgotPasswordComposite = () => {
  const forgotRef = React.useRef(null);
  const { localAppName } = React.useContext(AppContext);
  const isCapensis = localAppName === "capensis";
  const [failedReset, setFailedReset] = React.useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);

  const handleForgotDetails = (val: ForgotPasswordFormState) => {
    if (val) {
      axios
        .post(
          "/auth/forgotPassword",
          { EmailAddress: val.userName },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            withCredentials: true,
          }
        )
        .then((res: any) => {
          setIsSubmitted(true);
          if (res && res.data && res.data.Status === 200) {
            setFailedReset(false);
          } else {
            setFailedReset(true);
          }
        })
        .catch((FEerror: any) => console.log("FE error", FEerror));
    }
  };

  const handleForgotClicked = () => {
    if (forgotRef && forgotRef.current) {
      //@ts-ignore
      forgotRef.current.onSubmit();
    }
  };

  return (
    <WcStack
      alignItems="center"
      justifyContent={"center"}
      height="500px"
      width="500px"
      mt={!isCapensis ? 0 : "80px"}
      mb={!isCapensis ? 20 : 0}
      id="ForgotPasswordComposite"
    >
      <WcStack margin={!isCapensis ? 10 : 14} direction={"row"} spacing={2}>
        <Box
          component="img"
          sx={{
            height: !isCapensis ? 90 : 60,
          }}
          //@ts-ignore
          alt={!isCapensis ? "VBSO logo" : "Capensis logo"}
          src={
            !isCapensis
              ? "https://storage.googleapis.com/capensis-pub/VBSO-Logo.png"
              : "https://storage.googleapis.com/capensis-pub/Capensis-Logo_Gradient.png"
          }
        />
      </WcStack>
      <WcPaper>
        <WcStack alignItems={"center"} padding={4}>
          {!isSubmitted && (
            <WcStack m={4} spacing={8} justifyContent={"center"} alignItems="center" width="100%">
              <ForgotPasswordFormComposite
                onForgotPasswordDetails={handleForgotDetails}
                forgotRef={forgotRef}
                failedReset={failedReset}
                handleForgotClicked={handleForgotClicked}
              />
            </WcStack>
          )}

          {isSubmitted && !failedReset && (
            <WcStack m={4} spacing={8} justifyContent={"center"} alignItems="center" width="100%">
              <PasswordSentComposite setIsSubmitted={setIsSubmitted} setFailedReset={setFailedReset} />
            </WcStack>
          )}
        </WcStack>
      </WcPaper>
    </WcStack>
  );
};

export default ForgotPasswordComposite;
